import { enqueueSnackbar } from "notistack";
import { SaveModelMessages } from "../models/messages/Messages";
import { SaveModelResult } from "../services/model/SaveModel";
import "../styles/AppNotifications.css";

type BooleanAlert = (val: boolean[]) => void;
type ModelSaveAlert = (val: SaveModelResult[]) => void;
type Props = {
  children: (
    deleteFailedAlert: BooleanAlert,
    deleteSuccessAlert: BooleanAlert,
    reprocessFailedAlert: BooleanAlert,
    reprocessSuccessAlert: BooleanAlert,
    modelPagesFailedAlert: ModelSaveAlert,
    modelSaveSuccessAlert: ModelSaveAlert,
    modelSaveFailureAlert: ModelSaveAlert,
  ) => React.ReactElement;
};

export {
  AppNotifications,
  Props as AppNotificationsProps,
  BooleanAlert,
  ModelSaveAlert,
};

const AppNotifications = ({ children }: Props) => {
  const deleteFailedAlert = (results: boolean[]) => {
    if (results.length === 0) return;
    enqueueSnackbar({
      style: {
        borderColor: "#d32f2f",
        color: "#d32f2f",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 3500,
      message: `Failed deleting ${results.length} batch${results.length > 1 ? "es" : ""}`,
    });
  };
  const deleteSuccessAlert = (results: boolean[]) => {
    if (results.length === 0) return;
    enqueueSnackbar({
      style: {
        borderColor: "#43a047",
        color: "#43a047",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 3500,
      message: `Deleted ${results.length} batch${results.length > 1 ? "es" : ""}`,
    });
  };
  const reprocessFailedAlert = (results: boolean[]) => {
    if (results.length === 0) return;
    enqueueSnackbar({
      style: {
        borderColor: "#d32f2f",
        color: "#d32f2f",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 3500,
      message: `Failed reprocessing ${results.length} batch${results.length > 1 ? "es" : ""}`,
    });
  };
  const reprocessSuccessAlert = (results: boolean[]) => {
    if (results.length === 0) return;
    enqueueSnackbar({
      style: {
        borderColor: "#43a047",
        color: "#43a047",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 3500,
      message: `Reprocessed ${results.length} batch${results.length > 1 ? "es" : ""}`,
    });
  };
  // Called when model pages not saved
  const modelPagesFailedAlert = (noModelPages: SaveModelResult[]) => {
    enqueueSnackbar({
      style: {
        borderColor: "#d32f2f",
        color: "#d32f2f",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 5000,
      message: SaveModelMessages.noModelPages(
        noModelPages.map((x) => x.result.model!.name),
      ),
    });
  };
  // Called after models saved
  const modelSaveSuccessAlert = (results: SaveModelResult[]) => {
    enqueueSnackbar({
      style: {
        borderColor: "#43a047",
        color: "#43a047",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 5000,
      message: `Saved ${results.length} templates`,
    });
  };
  // Called after models saved
  const modelSaveFailureAlert = (results: SaveModelResult[]) => {
    enqueueSnackbar({
      style: {
        borderColor: "#d32f2f",
        color: "#d32f2f",
        backgroundColor: "#ffffff",
      },
      autoHideDuration: 5000,
      message: `Failed saving ${results.length} templates`,
    });
  };

  return children(
    deleteFailedAlert,
    deleteSuccessAlert,
    reprocessFailedAlert,
    reprocessSuccessAlert,
    modelPagesFailedAlert,
    modelSaveSuccessAlert,
    modelSaveFailureAlert,
  );
};
